// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Colours to be used */
/* Everything related to the Internationalization view */
/* Everything related to the Installation view */
/* Everything related to the navbar */
/* Everything related to alarm page list */
/* Everything related to alarm logs page */
/* Everything related to PWR table */
/*  */
.Pagination_pagination__YEe3O {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
}
.Pagination_pagination__YEe3O button {
  min-width: 3rem;
  height: 3rem;
  background-color: white;
  border-width: 1px 1px 1px 0;
  border-style: solid;
  border-color: #ddd;
  overflow: hidden;
}
.Pagination_pagination__YEe3O button:disabled {
  color: lightgray;
}
.Pagination_pagination__YEe3O button[data-current=true] {
  background-color: #454545;
  color: white;
  border-color: #454545;
}
.Pagination_pagination__YEe3O :first-child {
  min-width: 4rem;
  border-width: 1px;
  border-radius: 4px 0 0 4px;
}
.Pagination_pagination__YEe3O :last-child {
  min-width: 4rem;
  border-radius: 0 4px 4px 0;
}
.Pagination_pagination__YEe3O .Pagination_end-button__DsZD- {
  min-width: 8rem;
}
@media (max-width: 1024px) {
  .Pagination_pagination__YEe3O {
    display: flex;
    flex-direction: column;
  }
  .Pagination_pagination__YEe3O button {
    border-width: 0 1px 1px 1px;
  }
  .Pagination_pagination__YEe3O :first-child {
    border-width: 1px;
    border-radius: 4px 4px 0 0;
  }
  .Pagination_pagination__YEe3O :last-child {
    border-radius: 0 0 4px 4px;
  }
}`, "",{"version":3,"sources":["webpack://./src/utils/_utils.scss","webpack://./src/components/Misc/Pagination.module.scss"],"names":[],"mappings":"AAAA,uBAAA;AAEA,wDAAA;AAGA,gDAAA;AAMA,qCAAA;AASA,0CAAA;AAKA,0CAAA;AAGA,oCAAA;AAMA,KAAA;AChCA;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;AAOF;AALE;EACE,eAAA;EACA,YAAA;EACA,uBAAA;EAEA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAMJ;AAJI;EACE,gBAAA;AAMN;AAJI;EACE,yBAAA;EACA,YAAA;EACA,qBAAA;AAMN;AAFE;EACE,eAAA;EACA,iBAAA;EACA,0BAAA;AAIJ;AAFE;EACE,eAAA;EACA,0BAAA;AAIJ;AADE;EACE,eAAA;AAGJ;ADuBE;EC9DF;IAwCI,aAAA;IACA,sBAAA;EAGF;EADE;IACE,2BAAA;EAGJ;EAAE;IACE,iBAAA;IACA,0BAAA;EAEJ;EAAE;IACE,0BAAA;EAEJ;AACF","sourcesContent":[null,"/* Colours to be used */\n/* Everything related to the Internationalization view */\n/* Everything related to the Installation view */\n/* Everything related to the navbar */\n/* Everything related to alarm page list */\n/* Everything related to alarm logs page */\n/* Everything related to PWR table */\n/*  */\n.pagination {\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: row;\n}\n.pagination button {\n  min-width: 3rem;\n  height: 3rem;\n  background-color: white;\n  border-width: 1px 1px 1px 0;\n  border-style: solid;\n  border-color: #ddd;\n  overflow: hidden;\n}\n.pagination button:disabled {\n  color: lightgray;\n}\n.pagination button[data-current=true] {\n  background-color: #454545;\n  color: white;\n  border-color: #454545;\n}\n.pagination :first-child {\n  min-width: 4rem;\n  border-width: 1px;\n  border-radius: 4px 0 0 4px;\n}\n.pagination :last-child {\n  min-width: 4rem;\n  border-radius: 0 4px 4px 0;\n}\n.pagination .end-button {\n  min-width: 8rem;\n}\n@media (max-width: 1024px) {\n  .pagination {\n    display: flex;\n    flex-direction: column;\n  }\n  .pagination button {\n    border-width: 0 1px 1px 1px;\n  }\n  .pagination :first-child {\n    border-width: 1px;\n    border-radius: 4px 4px 0 0;\n  }\n  .pagination :last-child {\n    border-radius: 0 0 4px 4px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pagination": `Pagination_pagination__YEe3O`,
	"end-button": `Pagination_end-button__DsZD-`
};
export default ___CSS_LOADER_EXPORT___;
